import React from 'react';

import { SCORE_OPTIONS_WITH_MULTIPLIER, SCORE_TYPE_AMOUNT, SCORE_TYPE_MULTIPLIER } from
  '../../../../Context/DynamicFormContext';

import WrapperWidget from '../Wrapper';
import InputText from '../../../FormFields/Text';
import InputNumber from '../../../FormFields/Number';
import InputSelect from '../../../FormFields/Select';
import Checkbox from '../../../FormFields/Checkbox';
import withConditionsAndTriggers from '../withConditionsAndTriggers';

export class NumberWidget extends React.PureComponent {
  renderConfigTab = (internalField, changeFieldValue, changeFieldError) => {
    const { api,field } = this.props;
    return (
      <div className='Widget_Form_Config'>
        <InputText label='Label' required value={ api.getFieldsVerbiage(internalField, 'label') }
                   onChange={ (v) => changeFieldValue('label', v) } error={ internalField.errors['label'] }
                   onError={ (error) => changeFieldError('label', error) }/>
        <InputText label='Description' value={ api.getFieldsVerbiage(internalField, 'description') }
                   onChange={ (v) => changeFieldValue('description', v) }/>
        <InputText label='Placeholder' value={ api.getFieldsVerbiage(internalField, 'placeholder') }
                   onChange={ (v) => changeFieldValue('placeholder', v) }/>
        <InputSelect label='Score type' options={ SCORE_OPTIONS_WITH_MULTIPLIER } value={ internalField.scoreType }
                     onChange={ (v) => changeFieldValue('scoreType', v) }/>
        <InputNumber label='Min Length' value={ internalField.minLength }
                   onChange={ (v) => changeFieldValue('minLength', v) }/>
        <InputNumber label='Max Length' value={ internalField.maxLength }
                   onChange={ (v) => changeFieldValue('maxLength', v) }/>
        <InputSelect label='Display Width' 
                    value={ internalField.display_width }
                    onChange={ (v) => changeFieldValue('display_width', v.value)
                    }
                    options={field.displayWidthOptions && field.displayWidthOptions.map((option) => {
                      return { value: option.value, label: option.value };
                    })}/>
        <div className='InputCheckboxesWrapper'>
          <Checkbox onChange={ (v) => changeFieldValue('labelInline', v) } label='Label inline'
                    checked={ internalField.labelInline }
                    className='InputCheckbox_Block'/>
          <Checkbox onChange={ (v) => changeFieldValue('required', v) } label='Required'
                    checked={ internalField.required }
                    className='InputCheckbox_Block'/>
          <Checkbox onChange={ (v) => changeFieldValue('photo', v) } label='Photo'
                    checked={ internalField.photo }
                    className='InputCheckbox_Block'/>
          <Checkbox onChange={ (v) => changeFieldValue('notes', v) } label='Notes'
                    checked={ internalField.notes }
                    className='InputCheckbox_Block'/>
        </div>
        <div className="InputCheckboxesWrapper">
          <Checkbox onChange={ (v) => changeFieldValue('lockDDR', v) } label='Lock in DDR'
                    checked={ internalField.lockDDR }
                    className='InputCheckbox_Block'/>
          <Checkbox onChange={ (v) => changeFieldValue('force_line_break', v) } label='Start new line / row'
                    checked={ internalField.force_line_break }
                    className='InputCheckbox_Block'/>
        </div>
        {internalField.scoreType.value === SCORE_TYPE_AMOUNT && (
          <div className="InputScore_Block">
            <hr/>
            <div className="Flex-vertical-center">
              <InputNumber 
                label='Score'
                value={internalField.score}
                onChange={ (v) => changeFieldValue('score', v) }
              />
              <Checkbox onChange={ (v) => changeFieldValue('scoreLockDdr', v) } label='Lock DDR' checked={internalField.scoreLockDdr} />
            </div>
          </div>
        )}
        {internalField.scoreType.value === SCORE_TYPE_MULTIPLIER && (
          <div className="InputScore_Block">
            <hr/>
            <div className="Flex-vertical-center">
              <InputNumber 
                label='Score'
                value={internalField.multiplierScore}
                onChange={ (v) => changeFieldValue('multiplierScore', v) }
              />
              <Checkbox onChange={ (v) => changeFieldValue('multiplierScoreLockDdr', v) } label='Lock DDR' checked={internalField.multiplierScoreLockDdr} />
            </div>
          </div>
        )}
      </div>
    );
  };

  render() {
    const { field, renderForm, value, onChange, onError, error, api} = this.props;
    const props = {
      ...this.props,
      renderForm: () => renderForm(this.renderConfigTab),
      formTitle: 'Number Input',
    };
    return (
      <WrapperWidget {...props}>
        <div className='NumberWidget'>
          <InputNumber
            disabled={ field.disabled }
            placeholder={api ?  api.getFieldsVerbiage(field, 'placeholder') : field.placeholder }
            required={ field.required }
            value={ value }
            onChange={ onChange }
            onError={ onError }
            error={ error }
            minlength={ field.minLength }
            maxlength={ field.maxLength }
          />
        </div>
      </WrapperWidget>
    );
  }
}

export const NumberWidgetEditable = withConditionsAndTriggers(NumberWidget);